import { Outlet, useLocation } from "react-router";
import { SettingsSidebar } from "@/components/settings/settings-sidebar";
import { SettingsMobileSectionHeader } from "@/components/settings/settings-mobile-section-header";

export function SettingsLayout() {
  const location = useLocation();
  // Trailing slash optional. The index route on /:workspaceId/settings is the
  // mobile menu (master view) — section pages need the back-arrow chrome,
  // the menu itself does not.
  const isAtMenu = /\/settings\/?$/.test(location.pathname);

  return (
    <div
      className="flex h-dvh flex-col overflow-hidden md:flex-row"
      style={
        {
          "--sidebar-background": "0 0% 98.4%",
          "--sidebar-foreground": "0 0% 9%",
          "--sidebar-border": "0 0% 89.8%",
          "--sidebar-primary": "0 0% 9%",
          "--sidebar-primary-foreground": "0 0% 98%",
          "--sidebar-accent": "0 0% 95%",
          "--sidebar-accent-foreground": "0 0% 9%",
        } as React.CSSProperties
      }
    >
      {/* Desktop sidebar — hidden on mobile so the section / menu owns the screen */}
      <div className="hidden md:flex md:h-full">
        <SettingsSidebar />
      </div>

      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {!isAtMenu && (
          <div className="md:hidden">
            <SettingsMobileSectionHeader />
          </div>
        )}
        <div className="flex-1 overflow-y-auto bg-background">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
